// extracted by mini-css-extract-plugin
export var label = "_qo-0";
export var link = "_qo-1";